import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doTransition, doWaitImageByTime, isAnnHate } from "../helpers/helpers";
import { images } from "./images";
import { V8EmilyAnnMovieNightAfter } from "./V8";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const V8EmilyAnnMovieNight = async (): Promise<any> => {
    if (isAnnHate()) {
        return jump(V8EmilyAnnMovieNight_AnnHate, "V8EmilyAnnMovieNight_AnnHate");
    }

    if (!ann.properties.isCorrupted) {
        if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
            doTransition(images.v8.V8EmilyMovieNight_36);
            mc.talk(`I'll put it here for now for safekeeping.`);
            ann.talk(`Hehe, I can't believe you carried it all the way here.`);
            mc.talk(`It wasn't a problem!`);
            mc.talk(`Let's go to the living room, I'll bet Emily is waiting for us there.`);

        } else if (Question.globalAnswers.V8AnnDateTargetsResults === "takeItEasy") {
            doTransition(images.v8.V8EmilyMovieNight_37);
            mc.talk(`I'll put it here for now for safekeeping.`);
            mc.talk(`Let's go to the living room, I'll bet Emily is waiting for us there.`);
        } else {
            doTransition(images.v8.V8EmilyMovieNight_0);
        }

        ImageClass.setImage(images.v8.V8EmilyMovieNight_0);
    } else {

        doTransition(images.v8.V8EmilyMovieNight_0);
    }
    emily.talk(`Finally!`);
    mc.talk(`Sorry, I guess we lost track of time.`);
    doWaitImageByTime({ ...images.v8.V8EmilyMovieNight_1, partialsToDisplay: [images.v8.V8EmilyMovieNight_1.partials.V8EmilyMovieNight_1_p, images.v8.V8EmilyMovieNight_1.partials.V8EmilyMovieNight_2_p] });
    emily.talk(`No worries! I was watching some Friends reruns in the meantime.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_1.partials.V8EmilyMovieNight_1_p);
    mc.talk(`Friends again? We all know that Seinfeld is the better series.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_1.partials.V8EmilyMovieNight_2_p);
    emily.talk(`Oh no! Don't you start with that one again!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_1);
    emily.talk(`Are you ok with the fact that your boyfriend prefers Seinfeld over Friends?`);
    ann.talk(`Ah... I don't mind... I love them both.`);
    emily.talk(`We'll talk about that later!`);
    emily.talk(`Anyway! I'm glad you decided to come over!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_3);
    emily.talk(`What do you think of my PJs?`);
    ann.talk(`Very cute! I like the cupcakes.`);
    if (ann.properties.isCorrupted) {
        emily.talk(`I'm glad you said so! I've never had a chance to get to know you.`);
        ImageClass.setImage(images.v8.V8EmilyMovieNight_4);
        ann.talk(`Hehe... I know.`);
    } else {
        emily.talk(`I'm trying to fix my first impression... I guess surprising you like that in my underwear wasn't a good idea...`);
        ann.talk(`It's fine. It's in the past!`);
        ImageClass.setImage(images.v8.V8EmilyMovieNight_4);
        emily.talk(`I'm so glad to hear that!`);
        emily.talk(`So let's get down to business!`);
        mc.think(`... To defeat the Huns!`);

    }
    ImageClass.setImage(images.v8.V8EmilyMovieNight_5);
    emily.talk(`I set everything up!`);
    emily.talk(`We got wine, beer, popcorn, energy drinks, you name it!`);
    if (ann.properties.isCorrupted) {
        emily.talk(`There is also water if you prefer.`);
        ann.talk(`No way! I'll take a glass of wine.`);
        emily.talk(`That's my girl!`);

    } else {
        emily.talk(`There is also water; ${mc.name} told me you might prefer that.`);
        ann.talk(`Yes, thank you!`);
    }
    emily.talk(`Let's sit!`);
    return jump(V8EmilyAnnMovieNight_Sitting, "V8EmilyAnnMovieNight_Sitting");
};

export const V8EmilyAnnMovieNight_AnnHate = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8EmilyNightAlone_0);
    mc.talk(`I'm here!`);
    doWaitImageByTime(images.v8.V8EmilyNightAlone_2);
    emily.talk(`Did you end up doing something other then playing video games all day?`);
    mc.talk(`Not really.`);
    emily.talk(`Haha, I figured as much.`);
    doWaitImageByTime(images.v8.V8EmilyNightAlone_3);
    emily.talk(`What do you think about my new PJ?`);
    mc.talk(`Looks good!`);
    mc.talk(`You always liked cup cakes.`);
    emily.talk(`Haha, that's true!`);
    doWaitImageByTime(images.v8.V8EmilyNightAlone_5);
    emily.talk(`I got everything ready already!`);
    mc.talk(`I can see that! Thanks!`);
    doWaitImageByTime(images.v8.V8EmilyNightAlone_7);
    emily.talk(`Are you ready to do this?`);
    ImageClass.setImage(images.v8.V8EmilyNightAlone_6);
    mc.talk(`I am. But are you going to fell asleep 2 minutes into the movie?`);
    ImageClass.setImage(images.v8.V8EmilyNightAlone_8);
    emily.talk(`Me? No way! I'm going to watch the whole thing!`);
    mc.talk(`Mmm...`);
    doWaitImageByTime(images.v8.V8EmilyNightAlone_12);
    empty.think(`*Click*`);
    doTransition(images.v8.V8EmilyNightAlone_14);
    mc.think(`I fucking knew it!`);
    mc.think(`In all my years of knowing her, she never managed to stay up while watching a movie!`);


    return jump(V8EmilyAnnMovieNight_AloneWithEmily, "V8EmilyAnnMovieNight_AloneWithEmily");
};
export const V8EmilyAnnMovieNight_Sitting = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8EmilyMovieNight_11);
    emily.talk(`Did you guys have fun at the amusement park?`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_10);
    ann.talk(`We did!`);
    ann.talk(`Except the part when I found out I have a fear of heights right at the top of the Ferris wheel.`);
    ann.talk(`But I got over it!`);
    if (Question.globalAnswers.V8AnnDateTargetsResults === "tryToHit") {
        ann.talk(`And ${mc.name} even won a big teddy bear for me!`);
        ImageClass.setImage(images.v8.V8EmilyMovieNight_11);
        emily.talk(`Wow! That's great!`);
        emily.talk(`And I'm not surprised!`);


    } else if (Question.globalAnswers.V8AnnDateTargetsResults === "takeItEasy") {
        ann.talk(`And ${mc.name} even won a teddy bear for me!`);
        ImageClass.setImage(images.v8.V8EmilyMovieNight_11);
        emily.talk(`I hope he won the biggest one there!`);
        ann.talk(`Ah... Almost the biggest!`);
        ImageClass.setImage(images.v8.V8EmilyMovieNight_11);
        emily.talk(`That's great!`);
        emily.talk(`And I'm not surprised!`);

    } else {
        mc.talk(`And ${mc.name} even try to win a teddy bear for me.`);
        emily.talk(`Tried? What happened?`);
        mc.talk(`It wasn't my best day... I kept missing the targets.`);
        emily.talk(`He must've missed on purpose! No way he didn't hit at least one.`);

    }
    emily.talk(`He used to throw pillows at me from across the house and hit me right in the face...`);
    ann.talk(`Hehe.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_6);
    mc.talk(`So, what are we watching?`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_7);
    emily.talk(`To be honest, I have no idea...`);
    emily.talk(`It's a thriller. I saw the trailer and it looked cool.`);
    mc.talk(`Sounds good enough.`);
    ann.talk(`I hope it's not scary.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_11);
    emily.talk(`It's not, but ${mc.name} is here to protect you either way!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_7);
    mc.talk(`Considering you were already drinking wine when we got here I don't think you'll reach the end of the movie...`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_8);
    emily.talk(`Nonsense!`);
    doWaitImageByTime(images.v8.V8EmilyMovieNight_12);
    emily.talk(`Are you ready???`);
    ann.talk(`Yes!`);
    if (ann.properties.isCorrupted) {

    } else {

        mc.think(`Let's get this over with so I could have some sexy time with Ann!`);
    }
    empty.think(`*Click*`);


    return jump(V8EmilyAnnMovieNight_AfterMovie, "V8EmilyAnnMovieNight_AfterMovie");
};
export const V8EmilyAnnMovieNight_AfterMovie = async (): Promise<any> => {

    doTransition(images.v8.V8EmilyMovieNight_14);
    mc.think(`The movie's done...`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_16);
    ann.talk(`Oh wow! It was actually good! Emily didn't disappoint!`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_15);
    mc.talk(`I'm glad you liked it!`, { method: "Whispering" });
    mc.talk(`You know what time is it?`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_16);
    ann.talk(`What?`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_15);
    if (ann.properties.isCorrupted) {
        mc.talk(`You know.... I was thinking.`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_16);
        ann.talk(`What?`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_15);
        mc.talk(`Let's go to my room! I'm in the mood.`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_17);
        ann.talk(`Oh.`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_18);
        mc.talk(`What's wrong? You are not feeling it?`, { method: "Whispering" });

        if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
            ImageClass.setImage(images.v8.V8EmilyMovieNight_17);
            ann.talk(`Oh no! It's just that Chris is waiting for me.`, { method: "Whispering" });
            ann.talk(`Or us, if you decided to join us.`, { method: "Whispering" });
            ImageClass.setImage(images.v8.V8EmilyMovieNight_18);
            mc.talk(`Oh fuck, I completely forgot about that.`, { method: "Whispering" });
            mc.talk(`Let me just wake Emily up.`, { method: "Whispering" });
            ImageClass.setImage(images.v8.V8EmilyMovieNight_17);
            ann.talk(`Oh, no! Let her sleep a bit more... I think she needs it.`, { method: "Whispering" });
            ImageClass.setImage(images.v8.V8EmilyMovieNight_16);
            ann.talk(`I'll just wait for you there and join us if you decide to.`, { method: "Whispering" });
            ImageClass.setImage(images.v8.V8EmilyMovieNight_15);
            mc.talk(`Sounds good.`, { method: "Whispering" });
            ImageClass.setImage(images.v8.V8EmilyMovieNight_16);
            ann.talk(`I'll see myself out.`, { method: "Whispering" });
            doWaitImageByTime(images.v8.V8EmilyMovieNight_21);
            ann.talk(`Muah!`, { method: "Whispering" });

            return jump(V8EmilyAnnMovieNight_AloneWithEmily, "V8EmilyAnnMovieNight_AloneWithEmily");
        }

    } else {
        mc.talk(`It's time for our sexy date!`, { method: "Whispering" });
        mc.talk(`Let me just wake up Emily and we can go to my room.`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_17);
        ann.talk(`Oh.`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_18);
        mc.talk(`What's wrong? Have you changed your mind?`, { method: "Whispering" });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_17);
    }
    ann.talk(`No... I just feel bad waking her up...`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_19);
    mc.talk(`I'll have to get her off the couch eventually...`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_20);
    ann.talk(`I know, but let her sleep a bit more... I think she needs it.`, { method: "Whispering" });
    ann.talk(`We can postpone our date to tomorrow night! I have one more day before leaving.`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_18);
    mc.talk(`Oh, right. For some reason I thought it was tomorrow.`, { method: "Whispering" });
    mc.talk(`Alright, but tomorrow we do it. I don't care if it's the end of the world!`, { method: "Whispering" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_16);
    ann.talk(`I promise! Hehe.`, { method: "Whispering" });
    ann.talk(`I'll see myself out.`, { method: "Whispering" });
    doWaitImageByTime(images.v8.V8EmilyMovieNight_21);
    ann.talk(`Muah!`);



    return jump(V8EmilyAnnMovieNight_AloneWithEmily, "V8EmilyAnnMovieNight_AloneWithEmily");
};
export const V8EmilyAnnMovieNight_AloneWithEmily = async (): Promise<any> => {

    doWaitImageByTime(images.v8.V8EmilyMovieNight_22);
    mc.think(`Now what?`);
    mc.think(`I guess I can let her sleep it off for another few minutes before waking her up...`);

    vanessa.talk(`That's weak sauce!`);
    vanessa.talk(`She is passed out! What about getting a sneak peek of those beautiful breasts?`);

    mc.think(`Vanessa? What the fuck? Where are you?`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_40);
    vanessa.talk(`Right here stupid.`);
    mc.think(`Ouch!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_41);
    vanessa.talk(`Come on! Don't tell me you don't want to!`);
    if (mc.properties.v6SawEmilyNudePhoto) {
        vanessa.talk(`You already saw her naked on her phone!`);
        if (Question.globalAnswers.v7EmilyShowerPeaked) {
            vanessa.talk(`And let's not forget how you peeped on her in the shower!`);
            vanessa.talk(`Which by the way was HOT!`);
        }

    } else if (Question.globalAnswers.v7EmilyShowerPeaked) {
        vanessa.talk(`We both know how you drooled over her while she was taking a shower!`);

    }
    ImageClass.setImage(images.v8.V8EmilyMovieNight_39);
    vanessa.talk(`Just look at this beautiful creature. Truly a goddess.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_42);
    vanessa.talk(`She's sleeping so soundly...`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_43);
    vanessa.talk(`Come on. Lower her shirt. She wouldn't even notice...`);

    mc.think(`...`);

    ann.talk(`No! Don't do it!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_44);
    ann.talk(`She is your ${emily.properties.relation}!`);
    ann.talk(`She allowed herself to fell asleep on your lap because she trusts you! Don't break that trust.`);

    doWaitImageByTime(images.v8.V8EmilyMovieNight_47);
    vanessa.talk(`What the fuck?!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_46);
    vanessa.talk(`How come she got the better outfit?!`);
    vanessa.talk(`She is blonde and even got wings?! What the fuck!?`);

    mc.think(`Hey relax! That's just what came to my mind.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_49);
    vanessa.talk(`You better come up with something better next time! I don't even have shoes!`);
    vanessa.talk(`Unless of course you have a foot fetish...`);
    mc.think(`I don't have a foot fetish! Can we just get back to the matter at hand?`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_48);
    ann.talk(`Just carry her to bed and go to your room. She'll appreciate it in the morning.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_41);
    vanessa.talk(`Or... You can appreciate her beautiful breasts and then carry her to bed.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_51);
    ann.talk(`You grew up together... If she wakes up it could ruin your relationship.`);
    vanessa.talk(`Or it could take your relationship to the next level!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_50);
    await mc.setQuestion(new Question({ text: `Quiet! Let me think.`, options: { think: true }, key: `V8EmilyMovieNightTouchHerBreasts` })
        .option({ title: `Expose her breast`, key: true })
        .option({ title: `Carry her to bed`, key: false }));


    if (Question.globalAnswers.V8EmilyMovieNightTouchHerBreasts) {
        return jump(V8EmilyAnnMovieNight_ExposeBreasts, "V8EmilyAnnMovieNight_ExposeBreasts");
    }
    mc.think(`I'll just carry her to bed.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_55);
    ann.talk(`You made the right choice.`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_49);
    vanessa.talk(`Are you stupid or what?`);
    vanessa.talk(`Don't let this perfect opportunity go to waste!`);
    mc.think(`I made up my mind!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_46);
    vanessa.talk(`I hope you are happy!`);
    return jump(V8EmilyAnnMovieNight_CarryHerToBed, "V8EmilyAnnMovieNight_CarryHerToBed");

};

export const V8EmilyAnnMovieNight_ExposeBreasts = async (): Promise<any> => {
    mc.think(`I'm going to do it.`);
    vanessa.talk(`Sweet!!!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_52);
    vanessa.talk(`High-five!`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_53, { duration: 0, shake: true, wait: 0.5 });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_54);
    vanessa.talk(`Ahhhhhhhh!`);
    doWaitImageByTime(images.v8.Anim_V8EmilyMCGrope.poster);
    mc.think(`Ok... I've made up my mind... Let's do this.`);
    ImageClass.setAnimation(images.v8.Anim_V8EmilyMCGrope, { wait: 4.5, duration: 0, loop: 0 });
    ImageClass.setImage(images.v8.Anim_V8EmilyMCHandMoving.poster, { duration: 0 });
    mc.think(`Slowly...`);
    mc.think(`It's so curvy and soft...`);
    ImageClass.setAnimation(images.v8.Anim_V8EmilyMCHandMoving, { duration: 0 });
    mc.think(`I'd like to think she'd want me to do this...`);
    mc.think(`Ok. That's enough. I better carry her to bed before she wakes up.`);
    await endReplay(replayScenesList.v8EmilyNight);


    return jump(V8EmilyAnnMovieNight_CarryHerToBed, "V8EmilyAnnMovieNight_CarryHerToBed");
};
export const V8EmilyAnnMovieNight_CarryHerToBed = async (): Promise<any> => {


    doTransition(images.v8.V8EmilyMovieNight_28);
    emily.talk(`Nam...`, { method: "Mumbling" });
    ImageClass.setImage(images.v8.V8EmilyMovieNight_29);
    mc.talk(`There we go...`);
    ImageClass.setImage(images.v8.V8EmilyMovieNight_30);
    mc.talk(`Slowly...`);
    if (mc.properties.emilyRelationship > 10) {
        ImageClass.setImage(images.v8.V8EmilyMovieNight_31);
        mc.talk(`Good night Emily.`, { method: "Whispering" });
        await mc.set((properties) => {
            properties.gotKissedByEmily = true;
        });
        ImageClass.setImage(images.v8.V8EmilyMovieNight_32);
        mc.think(`What the... Why is she grabbing me?`);
        ImageClass.setImage(images.v8.V8EmilyMovieNight_34);
        mc.think(`MMM!!!`);
        doWaitImageByTime(images.v8.V8EmilyMovieNight_35);
        mc.think(`Did that just happen?!`);

    } else {
        ImageClass.setImage(images.v8.V8EmilyMovieNight_31);
        mc.talk(`That's it.`, { method: "Whispering" });
        doWaitImageByTime(images.v8.V8EmilyMovieNight_35);
        mc.think(`Good night Emily.`);

    }

    await endReplay();

    return jump(V8EmilyAnnMovieNightAfter, "V8EmilyAnnMovieNightAfter");
};
